import { TrText } from "../components/TrText";
import { TrSpace } from "../components/TrSpace";
import { TrTextField } from "../components/TrTextField";
import { FormPageButton } from "../components/FormPageButton";
import { TrCheckboxWithMessage } from "../components/TrCheckboxWithMessage";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useCallback } from "react";
import { setNoteUrlToArray } from "../reducks/orders/operations";

export const InputNoteLink = () => {
    const dispatch = useDispatch();

    const [noteUrl1, setNoteUrl1] = useState("");
    const [noteUrl2, setNoteUrl2] = useState("");
    const [noteUrl3, setNoteUrl3] = useState("");
    const [noteUrl4, setNoteUrl4] = useState("");
    const [noteUrl5, setNoteUrl5] = useState("");
    const [identification, setIdentification] = useState(false);
    const [copyright, setCopyright] = useState(false);
    const [isIsAlertForNoteUrl, setIsAlertForNoteUrl] = useState(false);
    const [isIsAlertForIdentify, setIsAlertForIdentify] = useState(false);
    const [isIsAlertForCopyright, setIsAlertForCopyright] = useState(false);
    const inputNoteUrl1 = useCallback((event) => {
        setNoteUrl1(event.target.value);
    }, [setNoteUrl1])

    const inputNoteUrl2 = useCallback((event) => {
        setNoteUrl2(event.target.value);
    }, [setNoteUrl2])

    const inputNoteUrl3 = useCallback((event) => {
        setNoteUrl3(event.target.value);
    }, [setNoteUrl3])

    const inputNoteUrl4 = useCallback((event) => {
        setNoteUrl4(event.target.value);
    }, [setNoteUrl4])

    const inputNoteUrl5 = useCallback((event) => {
        setNoteUrl5(event.target.value);
    }, [setNoteUrl5])
    
    const inputIdentification = useCallback((event) => {
        setIdentification(event.target.checked);
    }, [setIdentification])

    const inputCopyright = useCallback((event) => {
        setCopyright(event.target.checked);
    }, [setCopyright])

    function checkValidate() {
        if(noteUrl1 === "") {
            setIsAlertForNoteUrl(true);
        }else{
            setIsAlertForNoteUrl(false);
        }

        if (!identification && !copyright) {
            setIsAlertForIdentify(true)
            setIsAlertForCopyright(true)
        } else {
            setIsAlertForIdentify(false)
            setIsAlertForCopyright(false)
        }
    }


    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>本にするnoteの記事を選択</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="1つ目のURL"/>
                                <TrTextField id="url1" placeholder="1つ目のURL（必須）" isAlert={isIsAlertForNoteUrl} onChange={inputNoteUrl1}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="2つ目のURL"/>
                                <TrTextField id="url2" placeholder="2つ目のURL（任意）" isAlert={false} onChange={inputNoteUrl2}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="3つ目のURL"/>
                                <TrTextField id="url3" placeholder="3つ目のURL（任意）" isAlert={false} onChange={inputNoteUrl3}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="4つ目のURL"/>
                                <TrTextField id="url4" placeholder="4つ目のURL（任意）" isAlert={false} onChange={inputNoteUrl4}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="5つ目のURL"/>
                                <TrTextField id="url5" placeholder="5つ目のURL（任意）" isAlert={false} onChange={inputNoteUrl5}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="自分が書いたnoteを製本する場合"/>
                                <TrCheckboxWithMessage message="　リンク先の記事は私が書いたもので間違いありません" isAlert={isIsAlertForIdentify} onChange={inputIdentification}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="共同著者と書いたnoteを製本する場合"/>
                                <TrCheckboxWithMessage message="　リンク先の記事を製本する許可を共同著者から得ています" isAlert={isIsAlertForCopyright} onChange={inputCopyright}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton
                            text="次へ進む"
                            onClick={() => {
                                checkValidate();
                                dispatch(setNoteUrlToArray(noteUrl1, noteUrl2, noteUrl3, noteUrl4, noteUrl5, identification, copyright));
                            }}
                        />
                    </div>
                </main>
        </div>
    );
};